export default __webpack_public_path__ + "static/media/third.8e0912e8.png";